import { useModel as _useModel, mergeModels as _mergeModels, defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withKeys as _withKeys, createElementBlock as _createElementBlock } from "vue"

import { FormInput, FormSelect, FormSwitch } from "@easy/ui/forms";
import { PageSection } from "@/apps/page/page.interfaces";
import { InPageUsedTools } from "@/apps/page/page-project.interface";
import { computed } from "vue";
import { t } from "@/i18n";
import {
    TAB_EXISTING_PROJECT,
    TAB_NEW_PROJECT,
} from "@/apps/page/project/sections/useBindWithProject";


export default /*@__PURE__*/_defineComponent({
  __name: 'BindSectionWithToolProjectForm',
  props: /*@__PURE__*/_mergeModels({
    sectionId: {},
    tool: {},
    toolProjects: {},
    pageNameBlur: {},
    projectNameError: {},
    isAutofocused: { type: Boolean, default: true }
  }, {
    "selectedTab": {},
    "selectedTabModifiers": {},
    "shouldHaveExistingOption": {},
    "shouldHaveExistingOptionModifiers": {},
    "chosenProjectId": {},
    "chosenProjectIdModifiers": {},
    "projectName": {},
    "projectNameModifiers": {},
  }),
  emits: /*@__PURE__*/_mergeModels(["tabSwitched", "actionSubmit"], ["update:selectedTab", "update:shouldHaveExistingOption", "update:chosenProjectId", "update:projectName"]),
  setup(__props: any) {



const selectedTab = _useModel(__props, "selectedTab");
const shouldHaveExistingOption = _useModel(__props, "shouldHaveExistingOption");
const chosenProjectId = _useModel(__props, "chosenProjectId");
const projectName = _useModel(__props, "projectName");

const tabs = computed(() => {
    const tabList = [];
    if (shouldHaveExistingOption.value) {
        tabList.push({
            label: t("page.bind_section_modal.project_existing"),
            value: TAB_EXISTING_PROJECT,
        });
    }
    tabList.push({
        label: t("page.bind_section_modal.project_new"),
        value: TAB_NEW_PROJECT,
    });
    return tabList;
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    (tabs.value.length > 1)
      ? (_openBlock(), _createBlock(_unref(FormSwitch), {
          key: 0,
          class: "my-4",
          modelValue: selectedTab.value,
          "onUpdate:modelValue": [
            _cache[0] || (_cache[0] = ($event: any) => ((selectedTab).value = $event)),
            _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('tabSwitched', $event)))
          ],
          options: tabs.value
        }, null, 8, ["modelValue", "options"]))
      : _createCommentVNode("", true),
    (selectedTab.value === _unref(TAB_NEW_PROJECT))
      ? (_openBlock(), _createBlock(_unref(FormInput), {
          key: 1,
          autofocus: _ctx.isAutofocused,
          required: "",
          modelValue: projectName.value,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((projectName).value = $event)),
          onKeyup: _cache[3] || (_cache[3] = _withKeys(($event: any) => (_ctx.$emit('actionSubmit')), ["enter"])),
          title: _ctx.$t('page.sections.new_project_name'),
          onBlur: _ctx.pageNameBlur,
          error: _ctx.projectNameError
        }, null, 8, ["autofocus", "modelValue", "title", "onBlur", "error"]))
      : (selectedTab.value === _unref(TAB_EXISTING_PROJECT))
        ? (_openBlock(), _createBlock(_unref(FormSelect), {
            key: 2,
            label: _ctx.$t('page.bind_section_modal.choose_project'),
            options: _ctx.toolProjects,
            value: chosenProjectId.value,
            placeholder: _ctx.$t('shared.search'),
            modelValue: chosenProjectId.value,
            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((chosenProjectId).value = $event))
          }, null, 8, ["label", "options", "value", "placeholder", "modelValue"]))
        : _createCommentVNode("", true)
  ]))
}
}

})